const gtagReportConversion = (url) => {
  const callback = () => {
    if (typeof (url) !== `undefined`) {
      window.location = url;
    }
  };
  window.gtag(`event`, `conversion`, {
    send_to: `AW-795929658/n3myCK7Au8kBELrYw_sC`,
    event_callback: callback,
  });
  return false;
};


export const trackGoogleConversion = () => {
  if (window) {
    if (window.gtag) {
      gtagReportConversion();
    }
  }
};
